"use client";
import { UserProvider } from "@/context/user-context";
import client from "@/lib/apollo-client";
import { ApolloProvider } from "@apollo/client";
import React from "react";
import { Toaster } from "sonner";
import { TooltipProvider } from "../ui/tooltip";
import { ThemeProvider } from "./theme-provider";
import { CookiesProvider } from "react-cookie";
import { TickerProvider } from "@/context/ticker-context";
import OneSignalProvider from "@/views/oneSignal";

type AppProvidersProps = {
  children: React.ReactNode;
  isLoggedIn: boolean;
};
const AppProviders = ({ children, isLoggedIn }: AppProvidersProps) => {
  return (
    <>
      <CookiesProvider defaultSetOptions={{ path: "/" }}>
        <ThemeProvider
          attribute="class"
          defaultTheme="light"
          enableSystem
          disableTransitionOnChange
        >
          <UserProvider isLoggedIn={isLoggedIn}>
            <TickerProvider>
              <ApolloProvider client={client}>
                <TooltipProvider delayDuration={0}>
                  <OneSignalProvider>{children}</OneSignalProvider>
                  <Toaster position="top-right" richColors />
                  {/* <ScrollToTop /> */}
                </TooltipProvider>
              </ApolloProvider>
            </TickerProvider>
          </UserProvider>
        </ThemeProvider>
      </CookiesProvider>
    </>
  );
};

export default AppProviders;
